export default __webpack_public_path__ + "static/media/file-text.cb603f65.svg";